import { InfiniteData, useInfiniteQuery, UseInfiniteQueryResult, useMutation, UseMutationOptions, UseMutationResult, useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { IPage, IPagedQueryOptions } from '../library/models/page';

export const useReactQuery = <TData = unknown, TError = Error>(baseQuery: UseQueryOptions<TData, TError> & { queryKey: readonly unknown[] }, options?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>): UseQueryResult<TData, TError> & { queryKey: readonly unknown[] } => {
    const query = useQuery({
        ...baseQuery,
        ...options
    });

    return {
        queryKey: baseQuery.queryKey,
        ...query
    };
};

/**
 * The paged counterpart of `useReactQuery`, for a service method built with
 * `createGetInfiniteQuery`. `fetchNextPage` is what a "show more" button calls; every page
 * it returns is a real request, so the screen only ever holds what it has asked for.
 */
export const useReactInfiniteQuery = <TItem = unknown>(baseQuery: IPagedQueryOptions<TItem>, options?: { enabled?: boolean }): UseInfiniteQueryResult<InfiniteData<IPage<TItem>>, Error> =>
    useInfiniteQuery({
        ...baseQuery,
        ...options,
    });

export const useReactMutation = <TData = unknown, TError = Error, TVariables = void, TContext = unknown>(baseMutation: UseMutationOptions<TData, TError, TVariables, TContext>, options?: Omit<UseMutationOptions<TData, TError, TVariables, TContext>, 'mutationFn'>): UseMutationResult<TData, TError, TVariables, TContext> => {
    return useMutation({
        ...baseMutation,
        ...options,
    });
};